module.exports = __webpack_public_path__ + "static/2021_logo.b9ae0949.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/2021_logo.png
// module id = 3022
// module chunks = 68671685732945